/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BalenaDeviceDto
 */
export interface BalenaDeviceDto {
    /**
     *
     * @type {string}
     * @memberof BalenaDeviceDto
     */
    ipAddress?: string;
    /**
     *
     * @type {number}
     * @memberof BalenaDeviceDto
     */
    belongsToFleetId?: number;
    /**
     *
     * @type {number}
     * @memberof BalenaDeviceDto
     */
    runningReleaseId?: number;
    /**
     *
     * @type {number}
     * @memberof BalenaDeviceDto
     */
    targetReleaseId?: number;
    /**
     *
     * @type {string}
     * @memberof BalenaDeviceDto
     */
    updateStatus?: BalenaDeviceDtoUpdateStatusEnum;
}

/**
 * @export
 */
export const BalenaDeviceDtoUpdateStatusEnum = {
    Rejected: "rejected",
    Downloading: "downloading",
    Downloaded: "downloaded",
    ApplyingChanges: "applying changes",
    Aborted: "aborted",
    Done: "done",
} as const;
export type BalenaDeviceDtoUpdateStatusEnum =
    (typeof BalenaDeviceDtoUpdateStatusEnum)[keyof typeof BalenaDeviceDtoUpdateStatusEnum];

/**
 * Check if a given object implements the BalenaDeviceDto interface.
 */
export function instanceOfBalenaDeviceDto(
    value: object,
): value is BalenaDeviceDto {
    return true;
}

export function BalenaDeviceDtoFromJSON(json: any): BalenaDeviceDto {
    return BalenaDeviceDtoFromJSONTyped(json, false);
}

export function BalenaDeviceDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): BalenaDeviceDto {
    if (json == null) {
        return json;
    }
    return {
        ipAddress: json["ipAddress"] == null ? undefined : json["ipAddress"],
        belongsToFleetId:
            json["belongsToFleetId"] == null
                ? undefined
                : json["belongsToFleetId"],
        runningReleaseId:
            json["runningReleaseId"] == null
                ? undefined
                : json["runningReleaseId"],
        targetReleaseId:
            json["targetReleaseId"] == null
                ? undefined
                : json["targetReleaseId"],
        updateStatus:
            json["updateStatus"] == null ? undefined : json["updateStatus"],
    };
}

export function BalenaDeviceDtoToJSON(value?: BalenaDeviceDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        ipAddress: value["ipAddress"],
        belongsToFleetId: value["belongsToFleetId"],
        runningReleaseId: value["runningReleaseId"],
        targetReleaseId: value["targetReleaseId"],
        updateStatus: value["updateStatus"],
    };
}
